import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import PunchOutN2RulesAction from '../../app/store/actions/punchOutN2Rules';

import FIELDS from '../../data/fields';

import TextArea from '../elements/textArea';

class PunchOutN2RuleFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      code: '',
      name: '',
      description: '',
      type: '',
      message: '',
      success: '',
      update: false,
    };
  }

  componentDidMount() {
    if (this.props.back.location.item) {
      const {
        id, code, name, description, type,
      } = this.props.back.location.item;

      this.setState({
        id,
        code,
        name,
        description,
        type,
        update: true,
      });
    }
  }

  goBack = () => {
    this.props.back.goBack();
  };

  isValidData = async () => {
    const {
      code, name, description, type,
    } = this.state;

    if (!code || !name || !description || !type) {
      await this.setState({ message: I18n.t('punchoutRuleError'), success: '' });
    } else {
      return true;
    }
  };

  createPunchOutRule = async () => {
    const {
      code, name, description, type,
    } = this.state;

    if (await this.isValidData()) {
      try {
        await this.props.createPunchOutRule({
          code,
          name,
          description,
          type,
        });
        this.setState({
          success: I18n.t('punchOutRuleCreated'),
          message: '',
          id: '',
          code: '',
          name: '',
          description: '',
          type: '',
          update: false,
        });
      } catch (err) {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      }
    }
  };

  updatePunchOutRule = async () => {
    const {
      id, name, description, type,
    } = this.state;

    if (await this.isValidData()) {
      try {
        await this.props.updatePunchOutRule({
          ruleId: id,
          name,
          description,
          type,
        });
        this.setState({ success: I18n.t('punchOutRuleUpdated'), message: '' });
      } catch (err) {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      }
    }
  };

  render() {
    const {
      code, name, description, type, message, success, id, update,
    } = this.state;

    return (
      <div className="form-main">
        <h2 className="header-form-client"><Translate value="punchOutRuleRegister" /></h2>
        <form>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="code" /></p>
            <input
              onChange={e => this.setState({ code: e.target.value })}
              type="text"
              className="form-control"
              aria-describedby="botãoComprar"
              placeholder=""
              value={code}
              maxLength={FIELDS.default}
              disabled={update}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="name" /></p>
            <input
              onChange={e => this.setState({ name: e.target.value })}
              type="text"
              className="form-control"
              aria-describedby="botãoComprar"
              placeholder=""
              value={name}
              maxLength={FIELDS.default}
            />
          </div>

          <TextArea
            title={<Translate value="description" />}
            onChange={e => this.setState({ description: e.target.value })}
            value={description}
            maxLength={FIELDS.copyright}
            placeHolder=""
            rows={3}
          />

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="type" /></p>
            <input
              onChange={e => this.setState({ type: e.target.value })}
              type="text"
              className="form-control"
              aria-describedby="botãoComprar"
              placeholder=""
              value={type}
              maxLength={FIELDS.default}
            />
          </div>

          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              <Translate value="return" />
            </button>
            {id
              ? (
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={() => this.updatePunchOutRule()}
                >
                  <Translate value="update" />
                </button>
              )
              : (
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={() => this.createPunchOutRule()}
                >
                  <Translate value="save" />
                </button>
              )
           }
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  createPunchOutRule: rule => dispatch(PunchOutN2RulesAction.createPunchOutN2Rule(rule)),
  updatePunchOutRule: rule => dispatch(PunchOutN2RulesAction.updatePunchOutN2Rule(rule)),
});

const mapStateToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PunchOutN2RuleFormComponent);
